import React from 'react';
import PropTypes from 'prop-types';

const Dialog = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...other}>
      <rect id="bound" width="24" height="24" fill="none" />
      <path id="Combined-Shape" d="M14.486,18,12.8,21.057a1,1,0,0,1-1.709.069L9.017,18H5a3,3,0,0,1-3-3V6A3,3,0,0,1,5,3H19a3,3,0,0,1,3,3v9a3,3,0,0,1-3,3Z" fill={color} fillRule="evenodd" opacity="0.3" />
      <path id="Combined-Shape-2" data-name="Combined-Shape" d="M6,7h9a1,1,0,0,1,0,2H6A1,1,0,0,1,6,7Zm0,4h5a1,1,0,0,1,0,2H6a1,1,0,0,1,0-2Z" fill={color} fillRule="evenodd" opacity="0.3" />
    </svg>
  );
}

Dialog.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

Dialog.defaultProps = {
  color: '#6f9eff',
  width: 24,
  height: 24,
};

export default Dialog;



// WEBPACK FOOTER //
// ./src/components/Icons/Dialog.jsx